// frontend/src/pages/reportpage/MonthlyBursaryTab.jsx
import React from 'react';

const MonthlyBursaryTab = ({
  monthInput,
  handleMonthChange,
  fetchMonthlyReport,
  isLoading,
  monthlyReport,
  exportExcel,
}) => {
  return (
    <div className="monthly-tab">
      <div className="form-grid">
        <div className="form-group">
          <label>Select Month</label>
          <input
            type="month"
            value={monthInput}
            onChange={handleMonthChange}
          />
        </div>
        <div className="form-group form-group-action">
          <button
            className="btn btn-primary"
            onClick={fetchMonthlyReport}
            disabled={isLoading || !monthInput}
          >
            {isLoading ? 'Loading...' : 'Generate Report'}
          </button>
        </div>
        {monthlyReport && monthlyReport.rows && monthlyReport.rows.length > 0 && (
          <div className="form-group form-group-action">
            <button
              className="btn btn-outline"
              onClick={exportExcel}
            >
              📥 Export Excel
            </button>
          </div>
        )}
      </div>

      {monthlyReport && monthlyReport.rows && (
        <div className="report-content">
          <div className="report-title-row">
            <h3>Bursary Deductions - {monthlyReport.monthYear}</h3>
            <button className="btn btn-outline btn-sm" onClick={() => window.print()}>
              🖨️ Print
            </button>
          </div>

          <div className="table-container">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Member ID</th>
                  <th>Member Name</th>
                  <th>Total Deductions</th>
                </tr>
              </thead>
              <tbody>
                {monthlyReport.rows.map((row, index) => (
                  <tr key={index}>
                    <td>{row.memberId}</td>
                    <td>{row.memberName}</td>
                    <td><strong>KES {Number(row.totalDeduction || 0).toLocaleString()}</strong></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default MonthlyBursaryTab;
